module.exports = "/_next/static/images/yudukamiya-21260ab0c08b7e2d1c44686cb111f598.jpg";